import { Entity } from '../../../../../game';
import { SHIP } from '../../../../../traits';
import { ShipConfig, Vector } from '../../../../../types';
import { randMember } from '../../../../../utils';

export enum ShipDirection {
  Static,
  Left,
  Right,
}

export const MAX_LIVES = 3;

export class ShipEntity extends Entity {
  position: Vector = [0, 5, 0];
  velocity: Vector = [0, 0, 0];
  maxDistance: number = 100;
  emissiveColor?: string;
  maxVelocity: number = SHIP.maxVelocity;
  accelleration: number = SHIP.accelleration;
  direction: ShipDirection = ShipDirection.Static;
  hitEffectTimer: number = Infinity;
  powerupEffectTimer: number = Infinity;
  lives: number = MAX_LIVES;
  invincible: boolean = false;
  dead: boolean = false;
  blastOff: boolean = false;
  fireRate: number = SHIP.fireRate;
  fireTime: number = 0;
  poweringup?: boolean;
  powerupDuration: number = 0;
  size: Vector;

  constructor(shipConfig: ShipConfig) {
    super();
    this.size = [
      Number(shipConfig.params.blastersWidth) * 2 +
        Number(shipConfig.params.bodyWidth),
      Number(shipConfig.params.blastersLength),
      3,
    ];
  }

  hit() {
    if (this.invincible || this.blastOff) return;
    this.lives--;
    if (this.lives <= 0) this.dead = true;
    this.hitEffectTimer = 0;
  }

  powerup(duration: number) {
    this.powerupEffectTimer = 0;
    this.poweringup = true;
    this.powerupDuration = duration;
  }

  powerupEffect() {
    if (this.powerupEffectTimer <= this.powerupDuration) {
      this.emissiveColor = randMember([
        'red',
        'blue',
        'green',
        'yellow',
        'purple',
        'orange',
      ]);
    } else {
      this.emissiveColor = void 0;
      this.poweringup = false;
    }
  }

  hitEffect() {
    if (this.hitEffectTimer <= 0.1) {
      this.emissiveColor = 'white';
    } else if (this.hitEffectTimer <= 0.2) {
      this.emissiveColor = 'red';
    } else if (this.hitEffectTimer <= 0.3) {
      this.emissiveColor = 'white';
    } else if (this.hitEffectTimer <= 0.4) {
      this.emissiveColor = 'red';
    } else if (this.hitEffectTimer <= 0.5) {
      this.emissiveColor = void 0;
    }
  }

  step(delta: number) {
    if (this.dead) return;

    if (this.poweringup) {
      this.powerupEffect();
    } else {
      this.hitEffect();
    }

    this.hitEffectTimer += delta;
    this.powerupEffectTimer += delta;

    this.fireTime -= delta;

    const [x, y] = this.position;
    const [vx, vy] = this.velocity;

    // move
    this.position[0] = Math.min(
      this.maxDistance,
      Math.max(-this.maxDistance, x + vx),
    );
    this.position[1] = y + vy;

    // stop ship when it nears edge
    if (
      (x > this.maxDistance && this.direction === ShipDirection.Right) ||
      (x < -this.maxDistance && this.direction === ShipDirection.Left)
    ) {
      this.direction = ShipDirection.Static;
    }

    // accellerate
    if (this.blastOff) {
      this.velocity[1] += this.accelleration * delta;
    } else if (this.direction === ShipDirection.Static) {
      this.velocity[0] =
        vx > 0
          ? Math.max(0, vx - this.accelleration * delta)
          : Math.min(0, vx + this.accelleration * delta);
    } else if (this.direction === ShipDirection.Left) {
      this.velocity[0] = Math.max(
        vx - this.accelleration * delta,
        -this.maxVelocity,
      );
    } else if (this.direction === ShipDirection.Right) {
      this.velocity[0] = Math.min(
        vx + this.accelleration * delta,
        this.maxVelocity,
      );
    }
  }
}
